var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal',{attrs:{"to":"modals"}},[_c('transition',{attrs:{"name":"slide-up"}},[(_vm.visible)?_c('div',{staticClass:"overlay",on:{"click":function($event){if($event.target !== $event.currentTarget)return null;return _vm.handleClose.apply(null, arguments)}}},[_c('div',{staticClass:"panel"},[_vm._t("default")],2)]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }